export enum LegalBasis {
  CONSENT = "CONSENT",
  CONTRACT = "CONTRACT",
  LEGAL_OBLIGATION = "LEGAL_OBLIGATION",
  VITAL_INTEREST = "VITAL_INTEREST",
  PUBLIC_TASK = "PUBLIC_TASK",
  LEGITIMATE_INTEREST = "LEGITIMATE_INTEREST",
}

export enum BreachType {
  CONFIDENTIALITY = "CONFIDENTIALITY",
  INTEGRITY = "INTEGRITY",
  AVAILABILITY = "AVAILABILITY",
}

export enum BreachCause {
  INTERNAL_ERROR = "INTERNAL_ERROR",
  EXTERNAL_ATTACK = "EXTERNAL_ATTACK",
  LOST_DEVICE = "LOST_DEVICE",
  MISCONFIGURATION = "MISCONFIGURATION",
  THIRD_PARTY = "THIRD_PARTY",
  OTHER = "OTHER",
}

export enum RiskLevel {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export enum BreachStatus {
  OPEN = "OPEN",
  CONTAINED = "CONTAINED",
  CLOSED = "CLOSED",
}
